import {
  required,
  numberGreaterThan,
  numberGreaterThanOrEqualTo,
} from 'redux-freeform';

export const requireErrors = (error_text) => ({
  [required.error]: error_text,
});

export const paymentAmountErrors = {
  [required.error]: 'Payment amount is required',
  [numberGreaterThan.error]: 'Your payment must be more than $0.00',
  [numberGreaterThanOrEqualTo.error]:
    'Amount should be equal to or greater than order total',
};
